<template>
    <div>
        <div class="moremodule" :style="{'background-color':$abctheme.basecolor}">
            <!-- <div>
                <div>
                    半价专区
                </div>
                <div>

                </div>
            </div> -->
            <div class="fmodule" v-if="products&&products.length>0">
                <div class="m-wz">
                    <div class="line-fl">
                        <div class="line"></div>
                    </div>
                　　<div class="mtit">限购专区</div>
                    <div class="line-fr">
                        <div class="line"></div>
                    </div>
                </div>
                <div class="gooods">
                    <div class="myinfot"  v-for="(product,i) in products" :key="i" @click.stop="godetail1(product)">
                        <div class="myinfot-pic">
                           <img :src="$baseurl+product.productImageUrl">
                        </div>
                        <div class="myinfot-dd">
                            <div class="myinfot-info">
                                <div class="myinfot-info-tit van-multi-ellipsis--l2">{{product.title}}</div>
                                <div class="myinfot-info-cm">
                                    {{product.skus.length>1?'多':'单'}}尺码可选
                                     <span v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor,'margin-left':'5px'}">
                                        【海外产品】
                                    </span>
                                </div>
                               
                                <div class="myinfot-footer">
                                    <span class="myinfot-price">{{product.price}}</span> 
                                    <!-- <span class="myinfot-smtt">{{product.rSaleNum}}万人付款</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fmodule" v-if="products1&&products1.length>0">
                <div class="m-wz">
                    <div class="line-fl">
                        <div class="line"></div>
                    </div>
                　　<div class="mtit">半价专区</div>
                    <div class="line-fr">
                        <div class="line"></div>
                    </div>
                </div>
                <div class="gooods">
                    <div class="myinfot"  v-for="(product,i) in products1" :key="i" @click.stop="godetail(product)">
                        <div class="myinfot-pic">
                           <img :src="$baseurl+product.productImageUrl">
                        </div>
                        <div class="myinfot-dd">
                            <div class="myinfot-info">
                                <div class="myinfot-info-tit van-multi-ellipsis--l2">{{product.title}}</div>
                                <div class="myinfot-info-cm">
                                    {{product.skus.length>1?'多':'单'}}尺码可选
                                     <span v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor,'margin-left':'5px'}">
                                        【海外产品】
                                    </span>
                                </div>
                               
                                <div class="myinfot-footer">
                                    <span class="myinfot-price1">{{product.userPrice}}</span> 
                                    <span class="myinfot-price">{{product.price}}</span> 
                                    <!-- <span class="myinfot-smtt">{{product.rSaleNum}}万人付款</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fmain" :style="{'background-color':$abctheme.basecolor}"></div>
        </div>
        
         <retailfooter></retailfooter>
    </div>
</template>
<script>
export default {
    data(){
        return {
            queryparams:{
                loaded:false,
                loadingType: 'more',
                name: "",
                sku:"",
                ProductType:undefined,
                productSku: "",
                sorting: "",
                maxResultCount: 100,
                skipCount: 0,
                categoryId:0,
                filterindex:0,
                nextLevelPrice:false,
                isIntegral:false,
                isPurchaseLimit:true
            },
            queryparams1:{
                loaded:false,
                loadingType: 'more',
                name: "",
                sku:"",
                ProductType:undefined,
                productSku: "",
                sorting: "",
                maxResultCount: 100,
                skipCount: 0,
                categoryId:0,
                filterindex:0,
                nextLevelPrice:false,
                isIntegral:false,
            },
            products:[],
            products1:[]
        }
    },
    created(){
        this.queryinfo();
        this.queryhalfinfo();
    },
    methods:{
        queryinfo()
        {
            this.ajax.post('/api/services/app/PhoneCom/QueryProductList',this.queryparams).then(x => {
                this.products = x.result.items;
            })
        },
        queryhalfinfo()
        {
            this.ajax.post('/api/services/app/PhoneCom/QueryHalfProductList', this.queryparams1).then(x => {
                this.products1 = x.result.items;
            })
              
        },
        godetail1(item)
        {
            var productsku=item.productSku;
            this.$router.push({path:'/product/'+productsku});
        },
        godetail(item)
        {
            if(item.isCanBuy)
            {
                var productsku=item.productSku;
                this.$router.push({path:'/product/'+productsku});
            }
            else
            {
                this.$toast("您暂时没有该商品的半价优惠劵")
            }
        },
    }
}
</script>
<style lang="scss" scoped>

.moremodule{
    padding: 10px;
    font-size: 13px;
}
.fmodule{
    padding: 10px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
}


.m-wz{
    position: relative;
    text-align: center;
    margin-bottom: 10px;
}
.mtit{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.line-fl{
    position: absolute;
    left: 0;
    top:52%;
    width:38%;
    
}
.line-fr{
    position: absolute;
    right:0;
    top:52%;
    width:38%;
}
.line{
    border-top:1px solid #cccccc;
    width:100%;
}

.myinfot{
    position: relative;
    padding-left:85px;
    margin-bottom: 10px;
    .myinfot-pic{
        position: absolute;
        left:0;
        width: 80px;
        height: 80px;
        img{
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }
    }
    .myinfot-info{
        position: relative;
        min-height: 85px;
    }
    .myinfot-dd{
        line-height: 22px;
    }
    .myinfot-footer{
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        .myinfot-price{
            position: relative;
            padding-left: 14px;
            font-size: 16px;
            color:red;
        }
        .myinfot-price1{
            position: relative;
            padding-left: 14px;
            font-size: 16px;
            color:#a8a8a8;
            text-decoration:line-through;
            margin-right: 5px;
        }
        .myinfot-price1::before{
            content: "￥";
            position: absolute;
            left: 0;
            font-size: 14px;
            color:#a8a8a8;
            font-weight: bold;
        }

        .myinfot-price::before{
            content: "￥";
            position: absolute;
            left: 0;
            font-size: 14px;
            color:red;
            font-weight: bold;
        }
        .myinfot-smtt{
            float: right;
        }
    }   
    
}
.fmain{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index:-1;
}
</style>